<template>
  <div class="global-box security rectangle">
    <div class="content-box">
      <div class="unitary-item">
        <icon description="rep-security" size="48" />
        <p class="title">
          {{$t('index.security.title_security')}}
        </p>
        <p class="description">
          {{$t('index.security.description_security')}}
        </p>
      </div>
      <div class="unitary-item">
        <icon description="rep-confidence" size="48" />
        <p class="title">
          {{$t('index.security.title_confidence')}}
        </p>
        <p class="description">
          {{$t('index.security.description_confidence')}}
        </p>
      </div>
      <div class="unitary-item">
        <icon description="rep-privacity" size="48" />
        <p class="title">
          {{$t('index.security.title_privacity')}}
        </p>
        <p class="description">
          {{$t('index.security.description_privacity')}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'security',
  data() {
    return {

    };
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .security
    padding-bottom: 0 !important
    .content-box
      justify-content: space-evenly
      padding: 20px 0
      .unitary-item
        width: 30%
        display: flex
        flex-wrap: wrap
        justify-content: center
        svg
          fill: $grey-700
        .title
          width: 100%
          text-align: center
          font-weight: 600
          color: $brand-twoo
          text-transform: lowercase
          font-size: 18px
          font-style: italic
          margin: 12px 0
        .description
          text-align: center
          text-transform: lowercase
    @media (max-width: $widthTerciarySmall)
      .content-box
        .unitary-item
          width: 96%
          &:not(:first-child)
            margin-top: 20px
</style>
